import { Switch as MUISwitch, styled } from "@mui/material";

export const Switch = styled(MUISwitch)(({ theme }) => ({
    width: '28px',
    height: 16,
    padding: 0,
    display: 'flex',
    '&.MuiSwitch-root': {
        width: '28px',
    },
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    // The theme paints the checked thumb AND the checked track in the same accent blue, which merges
    // them into one solid blue pill with no visible knob. Keep the knob white, as the `color: '#fff'`
    // above already intends — that only drives `currentColor`, which the theme's explicit
    // `backgroundColor` overrides. `&&` is here to outweigh the theme selector's specificity.
    '&& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb': {
      backgroundColor: '#fff',
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
    },
  }));